<template>
  <div class="container">
    <section class="section">
      <h1 class="title">Datos personales</h1>
      <div class="field">
        <label class="label">Nombre</label>
        <div class="control">
          <input
            class="input"
            :class="classform.displayName"
            v-model="user.displayName"
            type="text"
            placeholder="Nombre"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">Teléfono</label>
        <div class="control">
          <input
            class="input"
            :class="classform.phoneNumber"
            v-model="user.phoneNumber"
            type="phone"
            placeholder="Teléfono"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">Cargo</label>
        <div class="control">
          <input
            class="input"
            :class="classform.job"
            v-model="user.job"
            type="text"
            placeholder="Cargo"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">Como te enteraste de nosotros</label>
        <div class="control">
          <textarea
            class="textarea"
            :class="classform.aboutus"
            v-model="user.aboutus"
            placeholder="Una breve descripción"
          ></textarea>
        </div>
      </div>

      <div class="field">
        <div class="control">
          <label class="checkbox">
            <input v-model="user.agree" type="checkbox" />
            Acepto <a href="#">los términos y condiciones</a>
          </label>
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" @click="saveUser">Aceptar</button>
        </div>
        <div class="control">
          <button class="button is-light" @click="cancel">Cancelar</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";

export default {
  data() {
    return {
      user: {
        displayName: null,
        phoneNumber: null,
        job: null,
        aboutus: null,
        agree: false,
      },
      classform: {
        displayName: null,
        phoneNumber: null,
        job: null,
        aboutus: null,
      },
    };
  },
  methods: {
    cancel() {
      try {
        this.$router.replace({ name: "clima" });
      } catch (err) {
        console.log(err);
      }
    },
    async saveUser() {
      if (!this.user.displayName) {
        this.$store.dispatch("notify", {
          message: "Debe indicar su nombre",
          type: "is-warning",
          position: "top-center",
        });
        this.classform.displayName = "is-danger";
        return false;
      } else {
        this.classform.displayName = null;
      }
      if (!this.user.phoneNumber) {
        this.$store.dispatch("notify", {
          message: "Debe indicar el teléfono",
          type: "is-warning",
          position: "top-center",
        });
        this.classform.phoneNumber = "is-danger";
        return false;
      } else {
        this.classform.phoneNumber = null;
      }
      if (!this.user.job) {
        this.$store.dispatch("notify", {
          message: "Debe indicar el cargo",
          type: "is-warning",
          position: "top-center",
        });
        this.classform.job = "is-danger";
        return false;
      } else {
        this.classform.job = null;
      }
      if (!this.user.aboutus) {
        this.$store.dispatch("notify", {
          message: "Cómo te enteraste de nosotros?",
          type: "is-warning",
          position: "top-center",
        });
        this.classform.aboutus = "is-danger";
        return false;
      } else {
        this.classform.aboutus = null;
      }
      if (!this.user.agree) {
        this.$store.dispatch("notify", {
          message: "Debe aceptar los términos y condiciones",
          type: "is-warning",
          position: "top-center",
        });
        return false;
      }
      await apiServices.put(`/updateuser`, this.user);
      this.$store.dispatch("notify", {
        message: "Perfecto. Datos guardados con éxito.",
        position: "top-center",
      });

      this.$router.replace({ name: "clima" });
      try {
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/clima/menuclima/Personalinformation.vue